import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

interface StyleProps {
  primaryColor: string;
  secondaryColor: string;
}

const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) =>
  createStyles({
    barcodeContainer: {
      padding: theme.spacing(2),
      width: '100%',
      backgroundColor: theme.palette.grey[50],
    },
    barcode: {
      margin: '0 auto',
      marginTop: theme.spacing(1),
      display: 'block',
    },
    referenceNumberTitle: {
      fontSize: '0.75rem',
      fontWeight: 600,
      textTransform: 'uppercase',
    },
    referenceNumber: {
      fontSize: '1rem',
    },
    instructions: {
      padding: theme.spacing(2),
      '& > ol': {
        padding: 0,
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        listStyle: 'none',
        counterReset: 'item',

        [theme.breakpoints.up('md')]: {
          marginBottom: theme.spacing(12),
        },
      },
      '& > ol > li': {
        position: 'relative',
        paddingLeft: theme.spacing(3),
        counterIncrement: 'item',
        marginBottom: theme.spacing(2),
        fontSize: '0.875rem',

        '&:before': {
          content: 'counter(item)',
          borderRadius: '100%',
          color: ({ primaryColor }) => `${primaryColor} !important`,
          opacity: 0.6,
          fontSize: '1rem',
          fontWeight: 700,
          textAlign: 'center',
          left: 0,
          position: 'absolute',
        },
      },
    },
    payWithCardButton: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(2),
      backgroundColor: ({ primaryColor }) => `${primaryColor} !important`,
    },
    copyIcon: {
      '& svg path': {
        fill: ({ primaryColor }: StyleProps) => primaryColor,
      },
    },
    link: {
      color: ({ secondaryColor }: StyleProps) => secondaryColor,
    },
    expirationDateIcon: {
      fontSize: 46,
      color: theme.oysterTheme.oyster,
      marginRight: theme.spacing(1),
    },
    expirationDateMessage: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      display: 'flex',
      alignItems: 'center',
      fontSize: 12,
      color: theme.oysterTheme.charcoal,
    },
    continueButton: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  }),
);

export default useStyles;
